import { useEffect, type KeyboardEvent } from 'react';

import { TOP_NAV_NO_SCROLL } from '../../constants';
import { goToPage } from '../../utils';
import { getSearchUrl } from '../../utils/getSearchUrl';

export const onEnterPressHandler = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === 'Enter') {
    const { value: searchQuery } = e.currentTarget;
    goToPage(getSearchUrl(searchQuery));
  }
};

export const useRemoveBodyScroll = (enabled: boolean) => {
  useEffect(() => {
    if (enabled) {
      document.body.classList.add(TOP_NAV_NO_SCROLL);
    } else {
      document.body.classList.remove(TOP_NAV_NO_SCROLL);
    }

    return () => {
      document.body.classList.remove(TOP_NAV_NO_SCROLL);
    };
  }, [enabled]);
};

interface ShouldShowBackdropParams {
  isMobile: boolean;
  isFocused: boolean;
  isMenuActive: boolean;
}
export const shouldShowBackdrop = ({ isMobile, isFocused, isMenuActive }: ShouldShowBackdropParams): boolean =>
  (isMobile && isFocused && !isMenuActive) || (!isMobile && (isFocused || isMenuActive));
